export const repeatOf = (s) => s.repeat || (s.date ? "once" : "daily");

export function timeKey(t = "") {
  const m = String(t).trim().match(/^(\d{1,2})(?:[:.](\d{2}))?\s*([ap]\.?m\.?)?/i);
  if (!m) return 24 * 60;
  let h = parseInt(m[1], 10) % 24;
  const min = parseInt(m[2] || "0", 10);
  const ap = (m[3] || "").toLowerCase();
  if (ap.startsWith("p") && h < 12) h += 12;
  if (ap.startsWith("a") && h === 12) h = 0;
  return h * 60 + min;
}

export const byTime = (a, b) => timeKey(a.time) - timeKey(b.time);

export const todayISO = () => new Date().toLocaleDateString("en-CA");

export const formatDate = (iso, lang = "en") =>
  new Date(`${iso}T00:00:00`).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
